import type { ReactElement } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../stores/auth-store';
import { AuthShell } from './auth-shell';

/** Layout for the auth pages. Sends signed-in users on to the right place. */
export function AuthLayout(): ReactElement {
  const user = useAuthStore((state) => state.user);

  if (user) {
    return <Navigate to={user.emailVerified ? '/dashboard' : '/verify-email'} replace />;
  }

  return (
    <AuthShell>
      <Outlet />
    </AuthShell>
  );
}
